<div class="card bg-transparent border-0 shadow">
    <div class="card-header bg-warning border-0">
        <div class="d-flex justify-content-between">
            <span>
                Error Logs
            </span>
            <span class="text-end">
                <button class="btn btn-danger btn-sm me-2" (click)="clearLogs()">
                    Clear Logs
                </button>
                <button class="btn btn-warning btn-sm me-2" (click)="downloadLogs()">
                    Download Logs
                </button>
                <button class="btn btn-light btn-sm rounded-square bg-light shadow-sm" (click)="dialogRef.close()">
                    <i class="fas fa-times"></i>
                </button>
            </span>
        </div>
    </div>
    <div class="card border-0 shadow-sm" >
        <div class="card-body" style="height: 70vh;overflow: scroll;">
            <div class="card m-1" *ngFor="let line of logs">
                <div class="card-body">
                    <code>
                        {{line}}
                    </code>
                </div>
            </div>
        </div>
    </div>
</div>